import { SET_BRAND_LOCALE } from "../actions/types";

const initialState = {
    brand: '',
    locale: ''
};

//Reducers
export default function (state = initialState, { type, payload = {} }) {
  switch (type) {
    case SET_BRAND_LOCALE:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
}
